"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getTagLiteral = void 0;
const effect_1 = require("effect");
/**
 * Retrieve the underlying literal value of a tag schema.
 * @param tag - The tag to get the literal value from
 * @returns The literal value of the tag
 */
const getTagLiteral = (
// Distribute T, so that S.tag is called with each member of T individually
// https://www.typescriptlang.org/docs/handbook/2/conditional-types.html#distributive-conditional-types
tag) => {
    const ast = effect_1.Match.value(tag.ast).pipe(effect_1.Match.withReturnType(), effect_1.Match.when({ _tag: 'PropertySignatureDeclaration' }, ({ type }) => type), effect_1.Match.when({ _tag: 'PropertySignatureTransformation' }, ({ to: { type } }) => type), effect_1.Match.exhaustive);
    if (effect_1.SchemaAST.isLiteral(ast))
        return ast.literal;
    throw new Error('AST is not of type Literal');
};
exports.getTagLiteral = getTagLiteral;
//# sourceMappingURL=tags.js.map